import React from 'react';
import { useTheme } from 'styled-components';

import { getColor } from '../../V2/Elements/Icons/helpers.ts';
import type { IIcon } from './types.ts';

const Icon = React.forwardRef<SVGSVGElement | null, IIcon>(function Icon({ size = 24, alt, color, className, onClick }, ref) {
  const theme = useTheme();
  const fillColor = React.useMemo(() => getColor({ color, alt, theme }), [color, alt, theme]);
  return (
    <svg ref={ref} onClick={onClick} width={size} height={size} viewBox='0 0 24 24' fill='none' className={className}>
      <path
        d='M13.5 4H7.5C7.10218 4 6.72064 4.15804 6.43934 4.43934C6.15804 4.72064 6 5.10218 6 5.5V17.5C6 17.8978 6.15804 18.2794 6.43934 18.5607C6.72064 18.842 7.10218 19 7.5 19H16.5C16.8978 19 17.2794 18.842 17.5607 18.5607C17.842 18.2794 18 17.8978 18 17.5V8.5L13.5 4Z'
        stroke={fillColor}
        strokeWidth='1.6'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path d='M13 4V9H18' stroke={fillColor} strokeWidth='1.6' strokeLinecap='round' strokeLinejoin='round' />
      <path d='M15 13H9' stroke={fillColor} strokeWidth='1.6' strokeLinecap='round' strokeLinejoin='round' />
      <path d='M15 16H9' stroke={fillColor} strokeWidth='1.6' strokeLinecap='round' strokeLinejoin='round' />
      <path d='M11 10H10H9' stroke={fillColor} strokeWidth='1.6' strokeLinecap='round' strokeLinejoin='round' />
    </svg>
  );
});

export default React.memo(Icon);
